var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplementalReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.53 3.44531V35.2938H155.379L123.53 3.44531Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.881 111.764C105.897 97.7274 111.48 84.2707 121.405 74.3457C131.331 64.4208 144.788 58.8382 158.824 58.8227V47.0591H111.764V0H23.5288V176.47H158.824V164.703C144.788 164.687 131.331 159.105 121.406 149.18C111.481 139.256 105.897 125.799 105.881 111.764ZM47.0577 35.2939H94.1172V47.0591H47.0577V35.2939ZM94.1172 141.176H47.0577V129.411H94.1172V141.176ZM94.1172 117.647H47.0577V105.882H94.1172V117.647ZM94.1172 94.1182H47.0577V82.3514H94.1172V94.1182ZM99.9991 70.5895H47.0577V58.8227H99.9991V70.5895Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.824 70.5876C150.68 70.5876 142.719 73.0026 135.948 77.527C129.176 82.0515 123.899 88.4822 120.782 96.0061C117.666 103.53 116.85 111.809 118.439 119.796C120.028 127.784 123.95 135.12 129.708 140.879C135.467 146.638 142.804 150.559 150.791 152.148C158.778 153.737 167.057 152.921 174.581 149.805C182.105 146.688 188.536 141.411 193.061 134.639C197.585 127.868 200 119.907 200 111.763C199.988 100.847 195.645 90.3808 187.926 82.6615C180.207 74.9423 169.741 70.6001 158.824 70.5876ZM154.664 130.125L138.74 114.201L147.059 105.883L154.664 113.489L174.031 94.1213L182.35 102.439L154.664 130.125Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7653 11.7651H0V200H147.059V188.235H11.7653V11.7651Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplementalReview);
export default __webpack_public_path__ + "static/media/SupplementalReview.bf1a3dc26034c972a05eecf59149d34b.svg";
export { ForwardRef as ReactComponent };